import classNames from 'classnames';
import TxtTitle from '../TxtTitle';
import FlexContainer from '../FlexContainer';
import ContentBlock from '../ContentBlock';
import Carousel from '../Carousel';
import View from '../View';
import Txt from '../Txt';
import Picture from '../Picture';
import Button from '../Button';
import Icon from '../Icon';
import styles from './ContentBlockWithPicture.module.scss';

/**
 * ContentBlockWithPicture
 *
 * @return {JSX.Element}
 */
const ContentBlockWithPicture = ({
  className,
  pictures = [],
  title,
  picturesTitle,
  subTitle,
  children,
  pictureKeyExtractor,
  horizontal,
  pictureRender = ({ src, alt }) => <Picture src={src} alt={alt} />,
  onClick,
  actions,
  bodyRelative,
  disableSlider,
  ...rest
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.ContentBlockWithPicture,
        onClick && styles.ContentBlockWithPicture__onClick,
        horizontal && styles.ContentBlockWithPicture__horizontal,
        bodyRelative && styles.ContentBlockWithPicture__bodyRelative,
        className,
        onClick && styles.ContentBlockWithPicture__onClick,
        `${ContentBlockWithPicture.displayName}`
      )}
      noPadding
      overflowHidden
      column={!horizontal}
      onClick={disableSlider ? onClick : undefined}
      {...rest}
    >
      <FlexContainer className={styles.Header}>
        {pictures.length ? (
          <Carousel
            flex
            data={pictures}
            renderItem={pictureRender}
            keyExtractor={pictureKeyExtractor}
            controls={!disableSlider}
            roundTrip
            showCounter={!disableSlider}
            // disabled={disableSlider}
          />
        ) : (
          <FlexContainer flex alignCenter justifyContentCenter>
            <Txt italic regular reverse>
              no pictures
            </Txt>
          </FlexContainer>
        )}
        {picturesTitle ? (
          <View className={styles.PicturesTitle}>
            <Txt>{picturesTitle}</Txt>
          </View>
        ) : null}
      </FlexContainer>
      <FlexContainer alignCenter flex={horizontal} className={styles.BodyWrap}>
        <FlexContainer
          flex
          column
          gapQuad
          className={styles.Body}
          onClick={disableSlider ? undefined : onClick}
        >
          {title ? (
            <View>
              <TxtTitle caption>{title}</TxtTitle>
            </View>
          ) : null}
          {subTitle ? (
            <View>
              <TxtTitle xx bold>
                {subTitle}
              </TxtTitle>
            </View>
          ) : null}
          <FlexContainer flex column>
            {children}
          </FlexContainer>
        </FlexContainer>
        {actions ? (
          <FlexContainer gapHalf className={styles.Actions}>
            {actions.map((a) => (
              <Button key={a.key} onClick={a.onClick}>
                {a.icon ? <Icon name={a.icon} /> : null}
                {a.title ? <Txt>{a.title}</Txt> : null}
              </Button>
            ))}
          </FlexContainer>
        ) : null}
      </FlexContainer>
    </ContentBlock>
  );
};

ContentBlockWithPicture.displayName = 'ContentBlockWithPicture';

export default ContentBlockWithPicture;
